import VueRouter from "vue-router";
import BookingView from "../components/views/BookingView.vue";
import GeneralInformation from "../components/views/GeneralInformation.vue";
import BookingsMove from "../components/views/MoveBooking.vue";
import Bookings from "../components/views/Bookings.vue";
import BookingsCreate from "../components/views/BookingsCreate.vue";
import SiteInformation from "../components/views/SiteInformation.vue";
import { isManagement, isOperator, isOperatorAdmin } from "../helpers/auth";
import useCurrentUserStore from "../store/userStore";
import Confirm from "./../components/views/Confirm.vue";
import ForgotPassword from "./../components/views/ForgotPassword.vue";
import Login from "../components/views/Login.vue";
import ResetPassword from "./../components/views/ResetPassword.vue";
import Application from "./../components/views/Application.vue";
import Applications from "./../components/views/Applications.vue";
import Tools from "../components/views/Tools.vue";
import XCubeControl from "./../components/views/XCubeControl.vue";
import EditBooking from "../components/views/BookingsEdit.vue";
import { fetchUserData } from "../api/graphql/users";
import Experiences from "../components/views/Experiences.vue";
import Experience from "../components/views/Experience.vue";
import LoginLinkPage from "../components/views/LoginLinkPage.vue";
import RequestLoginLinkPage from "../components/views/RequestLoginLinkPage.vue";
import Dashboard from "../components/views/Dashboard.vue";
import Contacts from "../components/views/Contacts.vue";
import OpeningHours from "../components/views/OpeningHours.vue";

const routes = [
    {
        path: "/confirm/:token",
        component: Confirm,
        meta: { public: true },
    },
    {
        path: "/login",
        component: Login,
        meta: { public: true },
        name: "login",
    },
    {
        path: "/reset-password/:token",
        component: ResetPassword,
        meta: { public: true },
        name: "ResetPassword",
    },
    {
        path: "/forgot-password",
        component: ForgotPassword,
        meta: { public: true },
        name: "ForgotPassword",
    },
    {
        path: "/login-link/:code",
        component: LoginLinkPage,
        meta: { public: true },
        name: "LoginLink",
    },
    {
        path: "/request-login-link",
        component: RequestLoginLinkPage,
        meta: { public: true },
        name: "RequestLoginLink",
    },
    {
        path: "/summary/:token",
        beforeEnter({ path }) {
            location.href = `${import.meta.env.VITE_APP_MY_XCUBE_URL}${path}`;
        },
        meta: { public: true },
    },
    {
        path: "/bookings",
        component: Bookings,
        name: "bookings",
        props: true,
    },
    {
        path: "/dashboard",
        component: Dashboard,
        name: "dashboard",
    },
    {
        path: "/applications/",
        component: Applications,
        name: "applications",
        meta: { admin: true },
    },
    {
        path: "/applications/:id",
        component: Application,
        name: "application",
        meta: { admin: true },
    },
    {
        path: "/tools",
        component: Tools,
        name: "tools",
        meta: { admin: true },
    },
    {
        path: "/xcubecontrol",
        component: XCubeControl,
        name: "xcube-control",
        meta: { admin: true },
    },
    {
        path: "/bookings/create",
        component: BookingsCreate,
        name: "create-booking",
    },
    {
        path:"/location",
        component: () => import("../components/views/Location.vue"),
        name: "location",
    },
    {
        path:"/location/:id/create-user",
        component: () => import("../components/views/CreateLocationUser.vue"),
        name: "create-location-user",
    },
    {
        path: "/bookings/move/:id",
        component: BookingsMove,
        name: "move-booking",
    },
    {
        path: "/information/general",
        component: GeneralInformation,
        name: "general-information",
    },
    {
        path: "/information/site",
        component: SiteInformation,
        name: "site-information",
    },
    {
        path: "/contacts",
        component: Contacts,
        name: "contacts",
    },
    {
        path: "/opening-hours",
        component: OpeningHours,
        name: "opening-hours",
    },
    {
        path: "/bookings/view/:id",
        component: BookingView,
        name: "view-booking",
    },
    {
        path: "/bookings/edit/:id",
        component: EditBooking,
        name: "edit-booking",
    },
    {
        path: "/experiences/",
        component: Experiences,
        name: "experiences",
        meta: { admin: true },
    },
    {
        path: "/experiences/:id",
        component: Experience,
        name: "experience",
        meta: { admin: true },
    },

];

const router = new VueRouter({ routes, mode: "history" });

router.beforeEach(async (to, from, next) => {
    if (to.fullPath.startsWith("/#")) {
        next(to.fullPath.substring(2));
        return;
    }
    const store = useCurrentUserStore();
    if (!store.currentUser) {
        try {
            await fetchUserData();
        } catch (e) {
            store.setCurrentUser(null);
        }
    }
    if (!store.currentUser) {
        console.log("NO CURRENT USER");
        if (to.meta.public) {
            console.log("BUT PUBLIC PLACE SO NO PROBLEM");
            next();
        } else {
            console.log("BUT RESTRICTED PLACE SO REDIRECT TO LOGIN");
            next({ name: "login" });
        }
    } else {
        if (to.name === "login" || to.path === "/") {
            console.log("API USER", store.currentUser);
            if (isManagement(store.currentUser) || isOperator(store.currentUser) || isOperatorAdmin(store.currentUser)) {
                console.log("REDIRECTING USER TO BOOKINGS");
                next({ name: "bookings" });
            } else {
                console.log("REDIRECTING USER TO MY X-CUBE");
                location.href = `${import.meta.env.VITE_APP_MY_XCUBE_URL}${to.path}`;
            }
        } else if (to.meta.admin && !isManagement(store.currentUser)) {
            console.log("API USER NO ADMIN SO REDIRECT TO BOOKINGS");
            next("/bookings");
        } else {
            console.log("EVERYTHING OK");
            next();
        }
    }
});

export default router;
